const initState = {
  loaded: false,
  isDefault: true,
  email: '',
  fullname: '',
  name: ''
};

export default initState;
